<template>
	<reqsType :baseUrlpath="baseUrlpath" :reqType="reqType"></reqsType>
</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	import reqsType from '@/components/reqsType.vue'
	export default {
		name: '本地旅游',
		metaInfo: {
			title: '中东华人宝-本地旅游',
			meta: [{
					name: 'keyWords',
					content: '本地旅游'
				},
				{
					name: 'description',
					content: '机票,酒店/民宿,接送机,包车旅游,门票甩卖,旅游项目,签证,旅行社,本地导游'
				}
			]
		},
		components: {
			reqsType
		},
		data() {
			return {
				baseUrlpath: '',
				reqType: '10'
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			var inchina = localStorage.getItem('inChina');
			if(inchina == '1'){
				this.baseUrlpath = this.baseUrlCN;
			}
		},
		methods: {}
	}
</script>

<style>
</style>